import React, { Component } from "react";
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import ActiveOrders from "./pages/ActiveOrders";
import ActiveCashOrders from "./pages/ActiveOrders/ActiveCashOrders.js";

import OrderHistory from "./pages/OrderHistory/OrderHistory.js";
import CashOrderReconHistory from "./pages/OrderHistory/CashOrderReconHistory.js";
import OrderSearch from "./pages/OrderHistory/OrderSearch.js";
import InventoryManagement from "./pages/InventoryManagement";
import MenuCustomization from "./pages/InventoryManagement/MenuCustomization.js";
import Menu from "./pages/InventoryManagement/Menu.js"
import MerchantOrderDetails from "./pages/MerchantOrderDetails";
import MerchantOrderItemDetails from "./pages/MerchantOrderDetails/MerchantOrderItemDetails.js";
import MerchantOrderSummary from "./pages/MerchantOrderSummary";
import InventoryApprove from "./pages/InventoryApprove";
import AllStoreOrderSummary from "./pages/AllStoreOrderSummary";
import BenefitProgram from "./pages/BenefitProgram";
import Settings from "./pages/Settings";
import OrderBookingDate from "./pages/OrderBookingDate";
import RejectRequest from "./pages/RejectRequest";
import RejectOrders from "./pages/RejectOrders";
import { Redirect } from "react-router-dom";
import PastBookingOrders from "./pages/PastBookingOrders";
import OrderPlaceStore from "./pages/OrderPlaceStore";
import DeliverySchedule from "./pages/DeliverySchedule";
import DeliveryDetails from "./pages/DeliveryDetails/DeliveryDetails"
import DeliveryQRCodeScreen from "./pages/DeliveryQRCodeScreen/DeliveryQRCodeScreen";
import DeliveryPersonScreen from "./pages/DeliveryPersonScreen/DeliveryPersonScreen";
import DeliveryLocationTracking from "./pages/DeliveryLocationTracking/DeliveryLocationTracking";
import CalendarHoliday from "./pages/CalendarHoliday/CalendarHoliday";
import Payments from "./pages/Payments/Payments";
import ActiveOrdersPaymentPending from "./pages/ActiveOrdersPaymentPending/ActiveOrdersPaymentPending";
import AddStaff from "./pages/AddStaff/AddStaff";
import Offers from "./pages/Offers/Offers";
import StoreDetails from "./pages/StoreDetails/StoreDetails";
import TrackOrderStatus from "./pages/TrackOrder/TrackOrderStatus";
import DeliverySlots from "./components/DeliverySlots/DeliverySlots.js"
import StoreUserRegistration from "./pages/StoreUserRegistration/StoreUserRegistration";
import SubScribeCategory from "./components/subscribecategory/SubScribeCategory";
import InventoryCategory from "./pages/InventoryManagement/InventoryCategory";
import Inventoryproducts from "./pages/InventoryManagement/Inventoryproducts";
import AdvanceOrders from "./pages/AdvanceOrders/AdvanceOrders.jsx";
// function Loading() {
//   return <div>Loading...</div>;
// }

// const Breadcrumbs = Loadable({
//   loader: () => import('./views/Base/Breadcrumbs'),
//   loading: Loading,
// });

// const Cards = Loadable({
//   loader: () => import('./views/Base/Cards'),
//   loading: Loading,
// });

// const Carousels = Loadable({
//   loader: () => import('./views/Base/Carousels'),
//   loading: Loading,
// });

// const Collapses = Loadable({
//   loader: () => import('./views/Base/Collapses'),
//   loading: Loading,
// });

// const Dropdowns = Loadable({
//   loader: () => import('./views/Base/Dropdowns'),
//   loading: Loading,
// });

// const Forms = Loadable({
//   loader: () => import('./views/Base/Forms'),
//   loading: Loading,
// });

// const Jumbotrons = Loadable({
//   loader: () => import('./views/Base/Jumbotrons'),
//   loading: Loading,
// });

// const ListGroups = Loadable({
//   loader: () => import('./views/Base/ListGroups'),
//   loading: Loading,
// });

// const Navbars = Loadable({
//   loader: () => import('./views/Base/Navbars'),
//   loading: Loading,
// });

// const Navs = Loadable({
//   loader: () => import('./views/Base/Navs'),
//   loading: Loading,
// });

// const Paginations = Loadable({
//   loader: () => import('./views/Base/Paginations'),
//   loading: Loading,
// });

// const Popovers = Loadable({
//   loader: () => import('./views/Base/Popovers'),
//   loading: Loading,
// });

// const ProgressBar = Loadable({
//   loader: () => import('./views/Base/ProgressBar'),
//   loading: Loading,
// });

// const Switches = Loadable({
//   loader: () => import('./views/Base/Switches'),
//   loading: Loading,
// });

// const Tables = Loadable({
//   loader: () => import('./views/Base/Tables'),
//   loading: Loading,
// });

// const Tabs = Loadable({
//   loader: () => import('./views/Base/Tabs'),
//   loading: Loading,
// });

// const Tooltips = Loadable({
//   loader: () => import('./views/Base/Tooltips'),
//   loading: Loading,
// });

// const BrandButtons = Loadable({
//   loader: () => import('./views/Buttons/BrandButtons'),
//   loading: Loading,
// });

// const ButtonDropdowns = Loadable({
//   loader: () => import('./views/Buttons/ButtonDropdowns'),
//   loading: Loading,
// });

// const ButtonGroups = Loadable({
//   loader: () => import('./views/Buttons/ButtonGroups'),
//   loading: Loading,
// });

// const Buttons = Loadable({
//   loader: () => import('./views/Buttons/Buttons'),
//   loading: Loading,
// });

// const Charts = Loadable({
//   loader: () => import('./views/Charts'),
//   loading: Loading,
// });

// const Dashboard = Loadable({
//   loader: () => import('./views/Dashboard'),
//   loading: Loading,
// });

// const CoreUIIcons = Loadable({
//   loader: () => import('./views/Icons/CoreUIIcons'),
//   loading: Loading,
// });

// const Flags = Loadable({
//   loader: () => import('./views/Icons/Flags'),
//   loading: Loading,
// });

// const FontAwesome = Loadable({
//   loader: () => import('./views/Icons/FontAwesome'),
//   loading: Loading,
// });

// const SimpleLineIcons = Loadable({
//   loader: () => import('./views/Icons/SimpleLineIcons'),
//   loading: Loading,
// });

// const Alerts = Loadable({
//   loader: () => import('./views/Notifications/Alerts'),
//   loading: Loading,
// });

// const Badges = Loadable({
//   loader: () => import('./views/Notifications/Badges'),
//   loading: Loading,
// });

// const Modals = Loadable({
//   loader: () => import('./views/Notifications/Modals'),
//   loading: Loading,
// });

// const Colors = Loadable({
//   loader: () => import('./views/Theme/Colors'),
//   loading: Loading,
// });

// const Typography = Loadable({
//   loader: () => import('./views/Theme/Typography'),
//   loading: Loading,
// });

// const Widgets = Loadable({
//   loader: () => import('./views/Widgets/Widgets'),
//   loading: Loading,
// });

// class RedirectToActiveOrders extends Component {
//   // constructor(props){
//   //   super(props)
//   // }
  
//   render() {
//     return <Redirect to="/activeorders" />;
//   }
// }
function RedirectToActiveOrders() {
  let loginMode = localStorage.getItem("loginMode");
  let storeInformation = JSON.parse(localStorage.getItem("storeInformation") || "{}");

  if (
    loginMode === "store" &&
    storeInformation.store &&
    storeInformation.store.foodcourtCashier === true
  ) {
    console.log("foodcourt in routes.js line 231");
    return <Redirect to="/activecashorders" />;
  } else {
     console.log("foodcourt in routes.js line 231");
    return <Redirect to="/activeorders" />;
  }
}

// https://github.com/ReactTraining/react-router/tree/master/packages/react-router-config
const routes = [
  { path: "/", exact: true, name: "Home", component: RedirectToActiveOrders },
  {
    path: "/activeorders",
    exact: true,
    name: "Active Orders",
    component: ActiveOrders,
  },
  {
    path: "/activecashorders",
    exact: true,
    name: "Active Orders",
    component: ActiveCashOrders,
  },
  
  {
    path: "/advanceorders",
    exact: true,
    name: "Advance Orders",
    component: AdvanceOrders,
  },

  {
    path: "/pastorders",
    exact: true,
    name: "Order History",
    component: OrderHistory,
  }, 
   {
    path: "/cashordersrecon",
    exact: true,
    name: "Cash Order Reconciliation",
    component: CashOrderReconHistory,
  },
  
  {
    path: "/OrderSearch",
    exact: true,
    name: "Order Search",
    component: OrderSearch,
  },

  
  {
    path: "/products/:id/:name",
    exact: true,
    name: "inventoryproducts",
    component: Inventoryproducts,
  },
  { path: "/settings", exact: true, name: "Settings", component: Settings },
  {
    path: "/inventoryapprove",
    exact: true,
    name: "Inventory Approved",
    component: InventoryApprove,
  },
  {
    path: "/inventorymanagement/:id/:name",
    exact: true,
    name: "Inventory Management",
    component: InventoryManagement,
  },
  
  {
    path: "/inventory",
    exact: true,
    // name: "Inventory Management",
    name:"Menu",
    //component: InventoryCategory,
    component: Menu,
    
  },
   {
    path: "/MenuCustomization",
    exact: true,
    // name: "Inventory Management",
    name:"Menu Customization",
    //component: InventoryCategory,
    component: MenuCustomization,
    
  },
  
  {
    path: "/benefitprogram",
    exact: true,
    name: "Benefit Program",
    component: BenefitProgram,
  },
  {
    path: "/orderdetails",
    exact: true,
    name: "Order Details",
    component: MerchantOrderDetails,
  },
  {
    path: "/orderitemdetails",
    exact: true,
    name: "Itemwise Details",
    component: MerchantOrderItemDetails,
  },
  {
    path: "/ordersummary",
    exact: true,
    name: "Order Summary",
    component: MerchantOrderSummary,
  },
  {
    path: "/storesordersummary",
    exact: true,
    name: "StoresOrderSummary",
    component: AllStoreOrderSummary,
  },
  {
    path: "/ordersbookingdate",
    exact: true,
    name: "OrderBookingDate",
    component: OrderBookingDate,
  },
  // {
  //   path: "/subscribedetails",
  //   exact: true,
  //   name: "subscribedetails",
  //   component: SubScribeCategory,
  // },
  {
    path: "/pastbookingorders",
    exact: true,
    name: "pastbookingorders",
    component: PastBookingOrders,
  },
  {
    path: "/cancelordersrequest",
    exact: true,
    name: "CancelOrdersRequest",
    component: RejectRequest,
  },
  {
    path: "/rejectorders",
    exact: true,
    name: "RejectOrders",
    component: RejectOrders,
  },
  {
    path: "/orderplacestore",
    exact: true,
    name: "Order Place Store",
    component: OrderPlaceStore,
  },
  {
    path: "/deliveryschedule",
    exact: true,
    name: "Delivery Schedule",
    component: DeliverySchedule,
  },
  {
    path: "/deliverydetails",
    exact: true,
    name: "Delivery Orders",
    component: DeliveryDetails,
  },
  {
    path: "/deliveryslots",
    exact: true,
    name: "Delivery Slots",
    component: DeliverySlots,
  },
  
  {
    path: "/delivery",
    exact: true,
    name: "Delivery",
    component: DeliveryQRCodeScreen,
  },
  {
    path: "/deliverypersons",
    exact: true,
    name: "Delivery Person",
    component: DeliveryPersonScreen,
  },
  {
    path: "/deliverylocationtracking",
    exact: true,
    name: "Delivery Location Tracking",
    component: DeliveryLocationTracking,
  },
  {
    path: "/calendarholiday",
    exact: true,
    name: "Calendar Holiday",
    component: CalendarHoliday,
  },
  {
    path: "/payments",
    exact: true,
    name: "Payments",
    component: Payments,
  },
  {
    path: "/paymentpendingorders",
    exact: true,
    name: "Payment Pending Orders",
    component: ActiveOrdersPaymentPending,
  },
  {
    path: "/addstaff",
    exact: true,
    name: "Add Staff",
    component: AddStaff,
  },
  {
    path: "/offers",
    exact: true,
    name: "Offers/Discount",
    component: Offers,
  },
  {
    path: "/storedetails",
    exact: true,
    name: "Store Details",
    component: StoreDetails,
  },
  {
    path: "/TrackPendingDelivery",
    exact: true,
    name: "TrackPendingDelivery",
    component: TrackOrderStatus,
  },
  {
    path: "/storeuserregistration",
    exact: true,
    name: "ResetPassword",
    component: StoreUserRegistration,
  },
  



  // { path: '/dashboard', name: 'Dashboard', component: Dashboard },
  // { path: '/theme', exact: true, name: 'Theme', component: Colors },
  // { path: '/theme/colors', name: 'Colors', component: Colors },
  // { path: '/theme/typography', name: 'Typography', component: Typography },
  // { path: '/base', exact: true, name: 'Base', component: Cards },
  // { path: '/base/cards', name: 'Cards', component: Cards },
  // { path: '/base/forms', name: 'Forms', component: Forms },
  // { path: '/base/switches', name: 'Switches', component: Switches },
  // { path: '/base/tables', name: 'Tables', component: Tables },
  // { path: '/base/tabs', name: 'Tabs', component: Tabs },
  // { path: '/base/breadcrumbs', name: 'Breadcrumbs', component: Breadcrumbs },
  // { path: '/base/carousels', name: 'Carousel', component: Carousels },
  // { path: '/base/collapses', name: 'Collapse', component: Collapses },
  // { path: '/base/dropdowns', name: 'Dropdowns', component: Dropdowns },
  // { path: '/base/jumbotrons', name: 'Jumbotrons', component: Jumbotrons },
  // { path: '/base/list-groups', name: 'List Groups', component: ListGroups },
  // { path: '/base/navbars', name: 'Navbars', component: Navbars },
  // { path: '/base/navs', name: 'Navs', component: Navs },
  // { path: '/base/paginations', name: 'Paginations', component: Paginations },
  // { path: '/base/popovers', name: 'Popovers', component: Popovers },
  // { path: '/base/progress-bar', name: 'Progress Bar', component: ProgressBar },
  // { path: '/base/tooltips', name: 'Tooltips', component: Tooltips },
  // { path: '/buttons', exact: true, name: 'Buttons', component: Buttons },
  // { path: '/buttons/buttons', name: 'Buttons', component: Buttons },
  // { path: '/buttons/button-dropdowns', name: 'Button Dropdowns', component: ButtonDropdowns },
  // { path: '/buttons/button-groups', name: 'Button Groups', component: ButtonGroups },
  // { path: '/buttons/brand-buttons', name: 'Brand Buttons', component: BrandButtons },
  // { path: '/icons', exact: true, name: 'Icons', component: CoreUIIcons },
  // { path: '/icons/coreui-icons', name: 'CoreUI Icons', component: CoreUIIcons },
  // { path: '/icons/flags', name: 'Flags', component: Flags },
  // { path: '/icons/font-awesome', name: 'Font Awesome', component: FontAwesome },
  // { path: '/icons/simple-line-icons', name: 'Simple Line Icons', component: SimpleLineIcons },
  // { path: '/notifications', exact: true, name: 'Notifications', component: Alerts },
  // { path: '/notifications/alerts', name: 'Alerts', component: Alerts },
  // { path: '/notifications/badges', name: 'Badges', component: Badges },
  // { path: '/notifications/modals', name: 'Modals', component: Modals },
  // { path: '/widgets', name: 'Widgets', component: Widgets },
  // { path: '/charts', name: 'Charts', component: Charts },
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes.js